import { apiClient } from './api'
import { Task } from '../types'

/**
 * Gets tasks
 * @param params - Query params
 * @returns Promise with task list
 */
export function getTasks(params?: { teamId?: string; userId?: string }) {
  return apiClient.get<Task[]>('/tasks', { params })
}

/**
 * Creates a new task
 * @param taskData - Task payload
 * @returns Promise with created task
 */
export function createTask(taskData: Partial<Task>) {
  return apiClient.post<Task>('/tasks', taskData)
}

/**
 * Updates a task
 * @param id - Task ID
 * @param data - Task fields to update
 * @returns Promise with updated task
 */
export function updateTask(id: string, data: Partial<Task>) {
  return apiClient.put<Task>(`/tasks/${id}`, data)
}

/**
 * Deletes a task
 * @param id - Task ID
 * @returns Promise void
 */
export function deleteTask(id: string) {
  return apiClient.delete(`/tasks/${id}`)
}
